import { DEFAULT_PER_PAGE } from '@/data/constants'

/**
 * Builds URLSearchParams for paginated, sortable, and filterable API requests
 * @param {Object} options - The options for building search params
 * @param {number} [options.page=1] - Page number
 * @param {number} [options.perPage=DEFAULT_PER_PAGE] - Items per page
 * @param {string} [options.sortBy] - Field to sort by
 * @param {Object|Array} [options.orderBy] - Order by configuration
 * @param {string} [options.searchValue] - Search value to filter by
 * @param {string[]|string} [options.fields] - Fields to search in (all treated as text)
 * @param {Object} [options.additionalParams] - Additional params to append (key-value pairs)
 * @returns {URLSearchParams} - The built URLSearchParams object
 */
export const buildSearchParams = ({
  page = 1,
  perPage = DEFAULT_PER_PAGE,
  sortBy = null,
  orderBy = null,
  searchValue = null,
  fields = null,
  additionalParams = {},
} = {}) => {
  const searchParams = new URLSearchParams()

  // Pagination
  searchParams.append('page', page)
  searchParams.append('perPage', perPage)

  // Sorting
  if (sortBy) {
    searchParams.append('sortBy', sortBy)
  }
  if (orderBy) {
    searchParams.append('orderBy', JSON.stringify(orderBy))
  }

  // Filtering
  if (searchValue && fields?.length) {
    const filterBy = {
      value: searchValue,
      fields: Array.isArray(fields) ? fields : fields.split(',').map(field => field.trim()),
    }
    searchParams.append('filterBy', JSON.stringify(filterBy))
  }

  // Additional params (for endpoint-specific parameters)
  Object.entries(additionalParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      searchParams.append(key, String(value))
    }
  })

  return searchParams
}
